export default {
  home: {
    minute: " минут",
    hour: " часов",
    days: " дней",
    price_info:
      "Первые {mianfei} минут бесплатно. Максимальная плата за 24 часа — {currencyName}{fengding}. Ваш депозит {currencyName}{yajin} будет автоматически возвращён после возврата пауэрбанка",
    feature_1: "Включены все типы кабелей: iPhone, Type-C",
    feature_2: "Можно вернуть на любой станции",
    feature_3: "Доступна беспроводная зарядка",
    tips_1:
      "Ваш депозит {currencyName}{yajin} будет возвращён по окончании аренды",
    tips_2:
      "Депозит на пополнение {currencyName}{yajin} можно использовать для аренды, а после расходования вернуть",
    tips_3:
      "Текущий баланс {currencyName}{myyue}, его можно использовать для аренды напрямую",
    submit: "Начать аренду",
    borrow: "Арендовать",
    msg_fail_title: "Ошибка",
    msg_fail_content: "Аренда не удалась, попробуйте ещё раз",
    msg_rentcount: "У вас есть {zujieNum} незакрытых заказов",
    goborrow: "Взять заряд!!!",
    nearby: "Посмотреть ближайшие станции",
    preauth: "Предавторизация"
  },
  login: {
    code_title: "SMS‑подтверждение",
    phone_number: "Номер телефона",
    verification_code: "Введите код подтверждения из SMS",
    captcha_code: "Код",
    send_code: "Отправить код",
    login: "Войти",
    agree: "Нажимая «Войти», вы соглашаетесь с ",
    readme: "Пользовательским соглашением",
    msg_fail_login: "Не удалось войти",
    msg_success_login: "Вход выполнен",
    msg_fail_user: "Ошибка получения данных пользователя. Попробовать ещё раз?",
    sign_in_with: "Войти через",
    no_sms: "Не получили SMS",
    retry: "Отправить повторно"
  },
  confirm: {
    deletecard: "Удалить карту",
    addcard: "Введите данные карты",
    title: "Подтверждение оплаты",
    paynow: "Оплатить сейчас",
    SMSConfirm:
      "Пожалуйста, оплатите согласно SMS на вашем телефоне и нажмите кнопку подтверждения, чтобы продолжить.",
    pay_label: "Сумма",
    auth_label: "Предавторизация",
    price_tips:
      "Баланс можно вывести по запросу. Поступление на платёжный аккаунт может занять 1–5 рабочих дней.",
    auth_tips:
      "Предавторизация в размере {0}{1} обязательна. Фактическая сумма аренды будет списана при возврате пауэрбанка.",
    pay_type: "Выберите предпочтительный способ оплаты",
    submit: "Подтвердить оплату",
    msg_loading: "Загрузка...",
    msg_fail_title: "Предупреждение",
    msg_fail_payment: "Не удалось инициировать оплату депозита",
    msg_fail_order: "Не удалось создать заказ аренды",
    msg_fail_support: "Система не поддерживается",
    msg_fail_confirm: "Подтвердить",
    msg_fail_retry: "Повторить",
    msg_fail_cancel: "Отмена"
  },
  mine: {
    title: "Профиль пользователя",
    wallet: "Мой кошелёк",
    balance: "Мой баланс",
    deposit: "Депозит",
    wallet_in: "Пополнить",
    wallet_out: "Вывести",
    wallet_log: "История кошелька",
    rental_history: "История аренды",
    payment_title: "Способы оплаты",
    download_app: "Скачать приложение",
    settings: "Настройки",
    help: "Помощь",
    logout: "Выйти",
    login_tips: "Пожалуйста, войдите",
    msg_fail_title: "Ошибка",
    msg_fail_update: "Изменение не удалось. Попробуйте ещё раз",
    msg_loading: "Загрузка...",
    msg_fail_user: "Ошибка получения данных пользователя. Попробовать ещё раз?",
    edit_profile: "Редактировать профиль",
    join_us: "ПРИСОЕДИНЯЙТЕСЬ К НАМ",
    join_us_details: "Установите станцию Cargamos на вашей площадке"
  },
  msg: {
    appoffline: "Приложение ещё не запущено, пожалуйста, подождите",
    deletecard: "Вы уверены, что хотите удалить эту карту?",
    no_phone: "Требуется номер телефона",
    loading: "Загрузка...",
    title: "Подсказка",
    success: "Операция выполнена успешно",
    error: "Неизвестная ошибка. Пожалуйста, попробуйте позже",
    roleerror: "Недостаточно прав. Обратитесь к администратору.",
    neterror: "Сбой сетевого соединения. Пожалуйста, попробуйте позже",
    confirm: "Подтвердить",
    retry: "Повторить",
    cancel: "Отмена",
    title_fail: "Предупреждение",
    vieworder: "Посмотреть заказ",
    success_payment: "Оплата завершена",
    success_buy: "Покупка завершена",
    fail_payment: "Ошибка оплаты",
    keyword: "Ключевое слово",
    ispayorder: "Пожалуйста, подтвердите, что оплата произведена",
    unpay: "Не оплачено",
    yespay: "Оплачено",
    notopen: "Пока не открыто"
  },
  result: {
    tips:
      "Чтобы просматривать заказы и другие станции, пожалуйста, скачайте приложение.",
    download: "Скачать приложение",
    title: "Аренда подтверждена",
    gotit: "Понятно",
    price_plan: "Тариф",
    msg_success: "Аренда успешно оформлена",
    msg_tips_loading: "Пауэрбанк выдаётся, подождите...",
    msg_result_loading: "Результат оплаты подтверждается...",
    msg_fail_confirm: "Подтвердить",
    btn_usage: "Инструкция по использованию",
    btn_return: "Инструкция по возврату",
    deposit: "Депозит",
    msg_fail_content: "Запрос не выполнен. Пожалуйста, попробуйте ещё раз.",
    price_label: "в час",
    price_info:
      "Первые {mianfei} минут бесплатно, максимальная дневная плата {ccurrency}{fengding}. Депозит будет автоматически списан, когда аренда достигнет {ccurrency}{yajin}",
    tips_1: "Пожалуйста, возьмите пауэрбанк №{number}, как показано на рисунке",
    tips_2:
      "Пожалуйста, аккуратно уложите кабели и вставьте пауэрбанк в слот со стороной, отмеченной [стрелками вниз]",
    msg_note_usage:
      "Пауэрбанк оснащён 3 типами кабелей, выберите нужный для вашего устройства.",
    msg_note_return:
      "Пожалуйста, аккуратно уложите кабели и вставьте пауэрбанк в слот со стороной, отмеченной [стрелками вниз]",
    return_info:
      "При возврате убедитесь, что кабели аккуратно уложены, и вставьте сторону с металлическими контактами в свободный разъём до упора.",
    download_tips:
      "Чтобы арендовать наш пауэрбанк, вы можете выбрать один из следующих вариантов"
  },
  result_msg: {
    loading: "Загрузка...",
    refresh: "Обновить"
  },
  order: {
    title: "История аренды",
    in_use: "В использовании",
    ended: "Завершено",
    msg_error: "Запрос не выполнен",
    order_number: "№",
    order_details: "Детали заказа",
    order_zj_shop: "Место аренды",
    order_zj_time: "Время аренды",
    order_gh_shop: "Место возврата",
    order_gh_time: "Время возврата",
    order_use_time: "Время использования",
    order_amount: "Итоговая сумма",
    not_on_rent: "Не в аренде",
    renting: "В аренде",
    undone: "Не завершено",
    returned: "Возвращено",
    questions: "Вопросы",
    timeout_to_return: "Просрочка возврата",
    suspended_for_billing: "Приостановлено для начисления"
  },
  order_item: {
    order_number: "№",
    venue_rented: "Место получения",
    time_rented: "Время получения",
    venue_returned: "Место возврата",
    time_returned: "Время возврата",
    charge_standard: "Тариф",
    charge_standard_info:
      "{pJifei} {pCurrency} в час (первые {pMian} мин бесплатно)",
    rent_occurred: "Аренда оформлена",
    returned: "Возвращено",
    unreturned: "Не возвращено",
    type_0: "Не завершено",
    type_1: "В аренде",
    type_2: "Отменено",
    type_3: "Возвращено",
    type_4: "Произошла ошибка",
    type_5: "Просрочка",
    min: "мин",
    payment: "Оплата"
  },
  setting: {
    title: "Настройки",
    lang: "Язык"
  },
  help: {
    title: "Частые вопросы",
    rentals: "Аренда",
    venues: "Площадки",
    payments: "Платежи"
  },
  wallet_in: {
    title: "Пополнение баланса",
    price_label: "Сумма пополнения",
    price_placeholder: "Введите сумму пополнения",
    balance: "Текущий баланс",
    price_auto: "Выбрать сумму платежа",
    price_tips:
      "Баланс можно вывести по запросу. Поступление на платёжный аккаунт может занять 1–5 рабочих дней.",
    submit: "Отправить",
    loading: "Загрузка...",
    paying: "Переадресация на страницу оплаты...",
    msg_title: "Подсказки",
    msg_fail_order: "Не удалось создать заказ на пополнение",
    msg_fail_payment: "Не удалось инициировать оплату пополнения",
    msg_fail_retry: "Повторить"
  },
  wallet_out: {
    title: "Вывод средств",
    price_label: "Сумма вывода",
    price_placeholder: "Введите сумму вывода",
    balance: "Текущий баланс",
    balance_all: "Вывести всё",
    deposit: "Депозит",
    deposit_tips:
      "Есть незавершённый заказ аренды. Депозит Ksh{pyajin} не возвращается",
    submit: "Отправить",
    apply: "Подать",
    confirm: "Подтвердить",
    loading: "Загрузка...",
    msg_fail_price: "Неверная сумма вывода",
    msg_fail_balance: "Сумма вывода не может превышать текущий баланс",
    msg_fail_submit: "Пожалуйста, заполните все обязательные поля",
    msg_title: "Ошибка",
    msg_success_content: "Возврат выполнен",
    confirmtitle: "Подсказки",
    confirmcontent:
      "Текущий кошелёк не поддерживает вывод наличных. Пожалуйста, оставьте контактную информацию для ручной обработки возврата",
    payee_name: "Имя получателя",
    payee_bankcard: "Номер банковской карты",
    payee_phone: "Телефон",
    cancelText: "Отмена",
    confirmText: "Подать повторно"
  },
  map: {
    在线: "Открыто",
    离线: "Закрыто",
    title: "Ближайшая станция",
    result_msg: "Поблизости станций не найдено",
    msg_title: "ошибка",
    no_support: "Извините! Ваш браузер не поддерживает службы геолокации",
    my_position: "Моё местоположение",
    distance: "Расстояние:",
    shop_time: "Часы работы",
    free: "Доступно для аренды",
    return: "Доступные пустые слоты",
    shop_title: "Детали площадки",
    address: "Адрес",
    go_here: "Проложить маршрут",
    nav_help: "Помощь",
    nav_search: "Поиск"
  },
  scanQr: {
    NotAllowedError: "Необходимо предоставить доступ к камере",
    NotFoundError: "На этом устройстве нет камеры",
    NotSupportedError: "Требуется безопасный контекст (HTTPS, localhost)",
    NotReadableError: "Камера занята",
    OverconstrainedError: "Настройки камеры не подходят",
    StreamApiNotSupportedError: "Этот браузер не поддерживает потоковый API"
  },
  payment: {
    payment_title: "Способы оплаты",
    pay_type: "Пожалуйста, добавьте данные карты",
    add_payment_card: "Добавить платёжную карту",
    add_payment: "добавить оплату"
  },
  shop: {
    title: "Ближайшая станция",
    search_station: "Найти станцию",
    search_station_tips: "Введите название станции",
    shop_power_banks: "Пауэрбанки",
    shop_empty_slots: "Свободные слоты",
    shop_address: "Адрес",
    shop_business_hours: "Часы работы",
    shop_directions_station: "Построить маршрут к станции",
    shop_scan_qrcode: "Сканировать QR"
  },
  paymethod: {
    payamount: "Сумма оплаты",
    choosepaymethod: "Выбрать способ оплаты",
    addcard: "Добавить новую карту",
    confrimpay: "Подтвердить оплату",
    借记卡: "Дебетовая карта",
    银行卡列表: "Список банковских карт"
  },
  orderDetail: {
    price1: "{pJifei} {pCurrencyName} за {pJifeiDanwei} {priceUnit}",
    price2: "До {pFengding} {pCurrencyName} за 24 часа",
    price3: "Штраф за невозврат {overtimeAmount} {pCurrencyName}",
    venuerented: "Место аренды",
    venuereturned: "Место возврата",
    timerented: "Время аренды",
    timereturned: "Время возврата",
    powerbankid: "ID пауэрбанка",
    getreceipt: "ПОЛУЧИТЬ ЧЕК",
    buypowerbank: "Купить этот пауэрбанк",
    usetime: "Время использования",
    estimatedamount: "Оценочная сумма",
    feerule: "Правила тарифа",
    payment: "Оплата",
    orderNo: "№ заказа",
    trafficDetails: "Смотреть детали трафика пакета",
    Renewals: "Продления",
    FeeSchedule: "Тарифная сетка",
    HowToUse: "Как пользоваться",
    LeaseMerchant: "Арендодатель",
    startTime: "Время начала",
    ReturningMerchants: "Места возврата",
    EndTime: "Время окончания",
    Deposit: "Депозит",
    fee1: "Депозит оборудования {overtimeAmount} {pCurrencyName}",
    fee2:
      "Возврат в течение {overtime} дней после окончания аренды, минус {pFengding} {pCurrencyName} за 24 часа.",
    fee3:
      "Если оборудование возвращено в течение {overtime} дней после окончания аренды, будет удержано {overtimeAmount} {pCurrencyName}.",
    fee4:
      "Депозит будет автоматически списан, если оборудование не возвращено более чем через 15 дней после окончания срока аренды.",
    rentagain: "Арендовать снова",
    onrental: "В аренде",
    revoked: "Отменено",
    returned: "Возвращено",
    issue: "Проблема",
    overtimereturn: "Просрочка"
  },
  selectpackage: {
    powerbank: "Пауэрбанк",
    powerstation: "Станция",
    wifibox: "Wi‑Fi бокс",
    choosepackage: "Выберите пакет трафика",
    minute: " минут",
    首次免费: "Первые бесплатно ",
    最大每日收费: "Максимальная дневная плата ",
    devicedeposit: "Депозит за устройство",
    return_will_back: "Вернуть депозит после возврата устройства",
    lengthofuse: "Время использования",
    amountcharged: "Накопленная сумма",
    release_powerbank: "Получить пауэрбанк",
    see_pricing: "Посмотреть тарифы",
    deposit: "депозит",
    agreen: "Продолжая, вы соглашаетесь с ",
    privacy_policy: "Политикой конфиденциальности",
    and: " и ",
    terms_and_conditions: "Условиями использования.",
    per: "за",
    tips_1: "Залог {yajin}{currencyName} будет возвращён",
    tips_2:
      "Через {pOvertimeDay} дней будет начислено {overtimeAmount}{currencyName}"
  },
  rentcost: {
    rentcosttitle: "Сколько стоит аренда?",
    price1: "{jifei}{currency} за {jifeiDanwei} {priceUnit}",
    price2: "{fengding}{currency} в день",
    tip1:
      "Если вы не вернёте пауэрбанк в течение {overtime} дней, с вас будет списано {overtimeAmount}{currency}, и возвращать пауэрбанк не нужно.",
    tip2: "Аренда на один день — это 24 часа с момента получения пауэрбанка.",
    tip3:
      "Мы удержим {yajin}{currency} в качестве депозита, который будет возвращён после возврата батареи на станцию.",
    tip4:
      "Некоторые площадки могут предлагать бесплатные часы или скидки. Наслаждайтесь!",
    Days: "Дни",
    Hours: "Часы",
    Minutes: "Минуты",
    free: "{mianfei} минут бесплатно",
    willcharged: "С вас будет списано {money}{currency}"
  }
};
